import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import instrument from '@adc/instrument'
import {
  Button,
  Form,
  Dropdown,
  SelectField,
  Grid,
  useApplicationModals,
  useApplicationQueues,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import STATICS from '../../event.statics'
import analytics from '../../services/event.analytics'
import styles from './styles.scss'
const cx = classnames.bind(styles)

export const AssetsNavigationComponent = ({
  fetchAssets,
  elmId,
  downloadInventory,
  user,
  event = {},
  featureFlags,
}) => {
  let transFormedPageSize = [...STATICS.PAGE_SIZE]
  if (featureFlags['fe.resi.event.infinite-scroll-configuration']?.enabled) {
    transFormedPageSize = [
      {
        value:
          featureFlags['fe.resi.event.infinite-scroll-configuration']
            ?.batchSize,
        label: `${featureFlags['fe.resi.event.infinite-scroll-configuration']?.batchSize} per page`,
      },
      ...STATICS.PAGE_SIZE,
    ]
  }

  const [pageSize, setPageSize] = useState(transFormedPageSize[0])
  const [sortBy, setSortBy] = useState(STATICS.SORT_BY_LIST[0])
  const [inventoryDownloadInProgress, setInventoryDownloadInProgress] =
    useState(false)

  const modals = useApplicationModals()
  const queues = useApplicationQueues()

  const sortByAction = sortBy => {
    setSortBy(sortBy)
    fetchAssets({ sort: sortBy.value })
  }

  const pageSizeAction = pageSize => {
    setPageSize(pageSize)
    fetchAssets({
      limit: pageSize.value,
    })
  }

  const download = () => {
    setInventoryDownloadInProgress(true)

    // We are tracking this to determine whether anyone actually uses this and whether it's worth rebuilding instead of
    // just rebuilding something that nobody is using but we don't know if they are using
    instrument.increment('download_inventory_requested', 1)

    downloadInventory().finally(() => {
      setInventoryDownloadInProgress(false)
    })
  }

  const downloadIfAuthenticated = () => {
    if (user.logged_in) {
      download()
    } else {
      queues.postAuthentication.push([download])
      modals.open('authentication', {
        authInitialActive: STATICS.LOGIN,
        authModalIntent: STATICS.DOWNLOAD_INVENTORY_PROMPT,
      })
    }
    analytics.trackAttemptToDownloadInventory(event.event_id, user.logged_in)
  }

  return (
    <Form>
      <Grid>
        <Grid.Row style={{ justifyContent: 'flex-start', rowGap: 12 }}>
          <Grid.Column mobile={9} tablet={6} computer={6}>
            <SelectField
              elmId={`${elmId}_asset_sort_by`}
              // className={cx('u-ml-2')}
              name='sortBy'
              placeholder={sortBy.label}
              hideWrapper
              options={STATICS.SORT_BY_LIST.map(sortByOption => ({
                key: sortByOption.value,
                value: sortByOption.value,
                text: sortByOption.label,
                content: (
                  <Dropdown.Item
                    elmId={`${elmId}_asset_sort_by-option-${sortByOption.value}`}
                    key={`asset_sort_by_${sortByOption.value}`}
                    onClick={() => sortByAction(sortByOption)}
                  >
                    {sortByOption.label}
                  </Dropdown.Item>
                ),
              }))}
            />
          </Grid.Column>
          <Grid.Column mobile={7} tablet={4} computer={4}>
            <SelectField
              elmId={`${elmId}_asset_page_size`}
              // className={cx('u-ml-2')}
              name='sortBy'
              placeholder={pageSize.label}
              hideWrapper
              options={transFormedPageSize.map(pageSizeOption => ({
                key: pageSizeOption.value,
                value: pageSizeOption.value,
                text: pageSizeOption.label,
                content: (
                  <Dropdown.Item
                    elmId={`${elmId}_asset_page_size-option-${pageSizeOption.value}`}
                    key={`asset_page_size_${pageSizeOption.value}`}
                    onClick={() => pageSizeAction(pageSizeOption)}
                  >
                    {pageSizeOption.label}
                  </Dropdown.Item>
                ),
              }))}
            />
          </Grid.Column>
          <Grid.Column
            mobile={16}
            tablet={5}
            computer={5}
            className={cx('inventory-btn-wrapper')}
          >
            <Button
              elmId={`${elmId}_download_auction_inventory`}
              loading={inventoryDownloadInProgress}
              onClick={downloadIfAuthenticated}
              fluid
            >
              Download Inventory
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  )
}

AssetsNavigationComponent.propTypes = {
  elmId: PropTypes.string.isRequired,
  fetchAssets: PropTypes.func.isRequired,
  downloadInventory: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  event: PropTypes.object.isRequired,
  featureFlags: PropTypes.object.isRequired,
}

const mapStateToProps = store => ({
  user: store.user,
  event: store.event?.event,
  featureFlags: store.featureFlags,
})

export default connect(mapStateToProps)(AssetsNavigationComponent)
